import { Component, ViewEncapsulation } from '@angular/core';
import { FormComponent } from '../../form/form.component';

@Component({
  selector: 'c12',
  templateUrl: './c12.component.html',
  styleUrls: ['./c12.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class C12Component extends FormComponent {}



// WEBPACK FOOTER //
// ./src/app/client/c12/c12.component.ts